import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { PermissionStates } from '../../modules/permission/permission-controller/root';
import { UserPermInquirySelectors } from '../../modules/permission/user-permissions-inquiry-controller/selectors';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-company-drop-down',
  templateUrl: './select-multi-company-drop-down.component.html',
  styleUrls: ['./select-multi-company-drop-down.component.css']
})
export class SelectMultiCompanyDropDownComponent implements OnInit, OnDestroy {

  @Input() company: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Company';
  @Input() options: any;
  @Input() readPermissionDefintion;
  @Input() customColumns: [];

  @Output() companySelected = new EventEmitter<any[]>();

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = 'company';
  allSelected = false;
  filteredCache: any = [];
  compTargets: string[]=[];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  protected _onDestroy = new Subject<void>();
  private subs = new SubSink();

  constructor(private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });

    this.compTargets = SharedUtilitiesHelperFunctions.getTargetsByPermission(this.userPermissionTarget$,
      this.readPermissionDefintion, 'bl_fi_mst_comp'
    );
  }


  ngOnChanges() {
    //console.log('ngOnChanges');
  }

  getRowData() {
    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC"
    }

    if (this.customColumns && this.customColumns.length > 0) {
      formData['customColumns'] = this.customColumns;
    }
    
    this.dropDownService.get('company', formData, this.apiVisa).subscribe(resolved => {
      this.rowData = resolved.data;
      if(this.compTargets?.length>0){
        this.rowData = this.rowData.filter(record=>this.compTargets.includes(record.guid))
      }
      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      //fill the drop down
      this.filteredOptions$.next(this.rowData.slice());
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.code ?
          option.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(selectedComp: any[]) {
    if (selectedComp && selectedComp.length > 0) {
      this.company.patchValue(selectedComp);
      this.selectedRow = this.rowData.filter(row => selectedComp.includes(row.guid));
      this.companySelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.company.patchValue([...val.map(item => item.guid)]);
          //this.company.patchValue(val);
        } else {
          this.company.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.company && this.company.value) {
      this.filteredCache.forEach(el => {
        if (this.company.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
